import { css } from '@emotion/css';
import { Button, TextButton } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../../components/modal/modal';
import { uiConfig } from '../../../services/config';
import { type ResultStep } from '../../../store/survey';
import { ResultBox } from './result-box';

const header = css`
  font-family: ${uiConfig.styles.fontFamily};
  font-style: normal;
  font-weight: ${uiConfig.styles.fontWeights.regular};
  font-size: 21px;
  color: ${uiConfig.styles.colors.black};
  margin-bottom: 5px;
`;
const buttonContainer = css`
  margin: 12px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

interface RemoveModalProps {
  survey?: ResultStep;
  onRemove: () => void;
  onClose: () => void;
}
export function RemoveModal({
  survey,
  onRemove,
  onClose,
}: RemoveModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal
      show={Boolean(survey)}
      close={onClose}
      modalTitle={t('sureOnRemovePPData')}
      fitContent
    >
      {survey !== undefined && (
        <>
          <div className={header}>{t('sureOnRemovePPData')}</div>
          <ResultBox survey={survey} />
          <div className={buttonContainer}>
            <Button loading={false} type="submit" onClick={onRemove}>
              {t('button.delete')}
            </Button>
            <TextButton onClick={onClose}>{t('button.cancel')}</TextButton>
          </div>
        </>
      )}
    </Modal>
  );
}
